import { LiveNewsContentEntity, } from "@domains/entities/interfaces/iLiveNews";
export class LiveNewsDataMapper {
    mapTo(liveNewsData) {
        let entity = new Array();
        liveNewsData.map((item) => {
            let customElements = item.customElements;
            let chgp = "";
            let dpName = "";
            let hghlTxt = "";
            let sym = "";
            if (customElements.length > 0) {
                chgp = customElements[0].chgP;
                dpName = customElements[0].dpName;
                hghlTxt = customElements[0].hghlTxt;
                sym = customElements[0].sym;
            }
            let liveNewsContent = new LiveNewsContentEntity(item.category, item.desc, item.timeText, chgp, dpName, hghlTxt, sym);
            entity.push(liveNewsContent);
        });
        return entity;
    }
}
